<div class="p-6">
  <div mat-dialog-content>
    <h2 class="text-lg font-medium mb-4">ID needs to be lower than the OD!</h2>
  </div>
  <div mat-dialog-actions class="flex justify-end">
    <button mat-flat-button color="primary" [mat-dialog-close]="true">OK</button>
  </div>
</div>
